import { render } from "./biddings-list.component.vue?vue&type=template&id=bb8d49bc&ts=true"
import script from "./biddings-list.component.vue?vue&type=script&lang=ts"
export * from "./biddings-list.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__